
export const Training = () => {
  return (
    <div>
      <p>
        TUESDAYS: 8:00-9:30pm @ Craigowl Primary School <br />
        <iframe className="training" title="craigowl" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1333.5175019724422!2d-3.01327318533754!3d56.49597414080904!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x488642cea6a9c75f%3A0x9b569f59877617aa!2sCraigowl%20Primary%20School!5e0!3m2!1sen!2suk!4v1746279845765!5m2!1sen!2suk" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>      </p>
      <p>
      THURSDAYS: 6:30-8pm @ Ardler community centre <br/>
      <iframe className="training" title="ardler" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3606.548117583392!2d-3.012382564596426!3d56.489529126818276!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x488642d16bc0c8d1%3A0xd25a59478c5a6b11!2sArdler%20Complex!5e0!3m2!1sen!2suk!4v1723282793122!5m2!1sen!2suk" width="600" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </p>
    </div>
  )
}